<script setup lang="ts">
import { AuthLoginForm } from '../components/';

definePageMeta({
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
  layout: 'guest',
});

useHead({
  title: 'Login',
});
</script>
<template>
  <v-container class="d-flex mt-5xl">
    <AuthLoginForm data-testid="login-form" />
  </v-container>
</template>
<style lang="scss" scoped>
.v-form {
  width: 100%;
  max-width: 486px;
  position: relative;
  margin: auto;
}
</style>
